export default __webpack_public_path__ + "static/media/target.04a003e4.gif";